import templates from './templates';

const framework = {
  templates,
};

export default framework;
